<template>
  <AccessHandler
    :requiredRoleGroups="roleGroups"
    @accessChanged="(a: boolean) => (hasAccess = a)"
  />
  <div class="rfr-visits-page" data-cy="rfr-visits-page">
    <MasterPage :subApplication="SubApplicationTypes.ALL_FEATURES">
      <template v-if="hasAccess" v-slot:content>
        <header class="page__header--container clearfix">
          <h1 class="page__title--text pull-left">
            {{ pageTitle }}
          </h1>
        </header>
        <RfrVisitsView />
        <GlobalFooter />
      </template>
    </MasterPage>
  </div>
</template>

<script setup lang="ts">
import MasterPage from "@/views/MasterPage.vue";
import GlobalFooter from "@/views/GlobalFooter.vue";
import AccessHandler from "@/shared/access/AccessHandler.vue";
import { type RoleGroup, RfrVisitsGroup } from "@/shared/access/RoleGroups";
import { ref } from "vue";
import { SubApplicationTypes } from "@/Domain/SubApplicationTypes";
import RfrVisitsView from "./RfrVisitsView.vue";
import { EnumVisitMode } from "@/Domain/EnumVisitMode";

const urlParams = new URLSearchParams(window.location.search);
const menuType = urlParams.get("menu") ?? "VisitsAsRfr";

const roleGroups = [
  {
    roles: RfrVisitsGroup.roles,
    validateRestrictionsAsync: async () => menuType != "VisitsAsRc",
  },
] as RoleGroup[];

const hasAccess = ref<boolean>(false);

const mode =
  EnumVisitMode[urlParams.get("type") as keyof typeof EnumVisitMode] ??
  EnumVisitMode.Inspection;

const titles = {
  [EnumVisitMode.Inspection]: "Electronic Inspection Reports (EIR)",
  [EnumVisitMode.Financial]: "Electronic Financial Reports (EFR)",
  [EnumVisitMode.Historical]: "Electronic Inspection Reports (EIR) History",
  [EnumVisitMode.Overdue]: "Overdue Electronic Inspection Reports",
  [EnumVisitMode.Payable]: "Electronic Financial Reports (EFR) History",
};

const pageTitle = titles[mode];
</script>
